import clsx from "clsx";
import React from "react";
import { MenuProps, MenuItem, ListItemText, ListItemIcon } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {
  SendHorizontal as ResendInviteIcon,
  UserRoundMinus as RemoveInviteIcon,
} from "lucide-react";
import { Menu } from "./Menu";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

export interface PendingInviteMenuProps extends MenuProps {
  handleRevokeInvite: (event: any) => void;
  handleResendInvite: (event: any) => void;
  disabled?: boolean;
  isAdded?: boolean;
}

export function PendingInviteMenu(props: PendingInviteMenuProps) {
  const {
    className,
    onClose,
    handleRevokeInvite,
    handleResendInvite,
    disabled,
    isAdded,
    ...other
  } = props;
  const s = useStyles();

  return (
    <Menu
      MenuListProps={{ dense: true }}
      onClose={onClose}
      className={clsx(s.root, className)}
      {...other}
    >
      <MenuItem onClick={handleRevokeInvite} disabled={disabled} dense>
        <ListItemIcon children={<RemoveInviteIcon />} />
        <ListItemText primary={isAdded ? "Delete" : "Revoke Invite"} />
      </MenuItem>
      <MenuItem onClick={handleResendInvite} disabled={disabled} dense>
        <ListItemIcon children={<ResendInviteIcon />} />
        <ListItemText primary={isAdded ? "Send Invite" : "Resend Invite"} />
      </MenuItem>
    </Menu>
  );
}
